import React from "react";

interface LoadingSpinnerProps {
  message?: string;
  subMessage?: string;
  fullScreen?: boolean;
  size?: "sm" | "md" | "lg" | "xl";
  overlay?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "Cargando...",
  subMessage = "Por favor espera un momento",
  fullScreen = true,
  size = "md",
  overlay = false,
}) => {
  const sizeConfig = {
    sm: { logo: "h-10 w-10", ring: "h-16 w-16", padding: "p-5", title: "text-sm" },
    md: { logo: "h-14 w-14", ring: "h-24 w-24", padding: "p-7", title: "text-base" },
    lg: { logo: "h-16 w-16", ring: "h-28 w-28", padding: "p-8", title: "text-lg" },
    xl: { logo: "h-20 w-20", ring: "h-32 w-32", padding: "p-10", title: "text-xl" },
  };
  const currentSize = sizeConfig[size];

  const content = (
    <div
      role="status"
      aria-live="polite"
      className={`flex w-full max-w-sm flex-col items-center rounded-3xl border border-white/70 bg-white/80 text-center shadow-2xl shadow-slate-900/10 backdrop-blur-xl dark:border-slate-700/80 dark:bg-slate-950/80 dark:shadow-black/30 ${currentSize.padding}`}
    >
      <div className={`relative mb-5 flex items-center justify-center ${currentSize.ring}`}>
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full border-[3px] border-brand-soft border-t-brand-primary motion-safe:animate-spin"
        />
        <span aria-hidden="true" className="absolute inset-2 rounded-full bg-brand-soft" />
        <img
          src="/logos/logo.png"
          alt=""
          className={`relative z-10 object-contain ${currentSize.logo}`}
          draggable={false}
        />
      </div>

      <p className={`font-semibold leading-snug text-content-primary ${currentSize.title}`}>
        {message}
      </p>
      {subMessage && (
        <p className="mt-2 text-sm font-medium text-content-secondary">
          {subMessage}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div
        aria-busy="true"
        className="fixed inset-0 z-[1000] flex items-center justify-center bg-slate-900/20 p-4 backdrop-blur-[2px] dark:bg-black/35 sm:p-6"
      >
        {content}
      </div>
    );
  }

  if (overlay) {
    return (
      <div
        aria-busy="true"
        className="absolute inset-0 z-50 flex items-center justify-center rounded-card bg-white/45 p-4 backdrop-blur-sm dark:bg-slate-950/45"
      >
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;
